<template>
  <div class="page">
    <div class="main">
      <van-loading v-if="loading" class="loading" size="24px" vertical>加载中...</van-loading>

      <div class="header">
        <div class="headimg-and-nickname flex-box">
          <img class="headimg" :src="headimgurl">
          <div class="nickname">{{nickname}}</div>
        </div>
        <div class="distribute_code">分销编号：{{distribute_code}}</div>
        <div class="num-and-money flex-box">
          <div>累计订单量：{{total_entries}}笔</div>
          <div>累计佣金：{{sum_money}}元</div>
        </div>
      </div>

      <van-list
        class = "records"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了~"
        @load="onLoad"
        :immediate-check="immediateCheck">

        <div class="record" v-for="record in records" :key="record.id">
          <div class="record-title">{{record.title}}</div>
          <div class="price-and-usage flex-box">
            <div class="date">付款日期：{{record.date}}</div>
            <div class="price">佣金：¥{{record.commission}}</div>
          </div>
        </div>

      </van-list>

      <!-- <div class="records" v-if="!loading">
        <div class="record" v-for="record in records" :key="record.id">
          <div class="record-title">{{record.title}}</div>
          <div class="price-and-usage flex-box">
            <div class="date">付款日期：{{record.date}}</div>
            <div class="price">佣金：¥{{record.commission}}</div>
          </div>
        </div>
        <div class="no-more">"没有更多了～"</div>
      </div> -->

    </div>
  </div>
</template>

<script>
// import wx from 'weixin-js-sdk'
import { Toast, Dialog, Loading, List} from 'vant'

export default{
  components: {
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Loading.name]: Loading,
    [List.name]: List
  },
  data(){
    return {
      nickname: '',
      headimgurl: '',
      distribute_code: '',
      sum_money: '',
      records: [],
      loading: true,
      next_page: 1,
      total_entries: 1,
      total_pages: 1,
      finished: false,
      immediateCheck: false
    }
  },
  methods: {
    onLoad() {
      this.loading = true
      this.getRecords()
    },
    getRecords(){
      // console.log('getRecords this.next_page: ' + this.next_page)
      let openid = this.$store.state.userinfo.openid
      this.$api.get('/couple/get_order_history_by_distributor', {openid: openid, page: this.next_page}, res => {
        if(res.code == 200){
          this.loading = false
          this.records = this.records.concat(res.records)
          this.nickname = res.nickname
          this.headimgurl = res.headimgurl
          this.distribute_code = res.distribute_code
          this.sum_money = res.sum_money

          this.next_page = this.next_page + 1
          this.total_entries = res.paginate.total_entries
          this.total_pages = res.paginate.total_pages
          if(this.next_page >= this.total_pages){
            this.finished = true
          }
        }
      })
    }
  },
  mounted(){
    this.getRecords()
  }
}
</script>

<style scoped>
.page{
  min-height:100vh;
  background-color: #f8f8f8;
  padding:20px;
  width: 100%;
  height: 100%;
}
.loading{margin-top:30%;}
.records{font-size:22px;color:#8d8b8b;}
.records .record{
  width: 100%;
  background: #fff;
  margin-top: 30px;
  box-shadow: 0 5px 8px 0 rgb(51 51 51 / 5%);
  border-radius: 15px;
  padding:20px;
  /* border:1px solid #7273b1; */
}
.records .record .record-header{justify-content:space-between;border-bottom:1px solid #d2d6de;padding-bottom:20px;}
.records .record .record-title{font-size:28px;color:#333;font-weight:bold;text-align:left;margin-top:10px;margin-bottom:30px;}
.records .record .price-and-usage{justify-content:space-between;}
.records .record .usage{border:1px solid #8d8b8b;border-radius:5px;padding:2px 10px;margin-left:20px;}
.records .record .remain{border:1px solid #eb8e80;border-radius:5px;padding:2px 10px;color:#eb8e80;}
.records .no-more{font-size:22px;color:#8590a6;text-align:center;margin-top:20px;}

.header{
  background:#fff;padding:20px;color:#333;font-size:28px;text-align:left;
  box-shadow: 0 5px 8px 0 rgb(51 51 51 / 5%);
  border-radius: 15px;
}
.header .headimg{width:120px;height:120px;border-radius:120px;margin-right:30px;}
.header .nickname{font-size:35px;}
.header .distribute_code{margin-top:20px;margin-bottom:20px;}
.header .num-and-money{justify-content: space-between;}
</style>
